import * as Sentry from "@sentry/browser";

export function setup(config) {
  Sentry.init(config);
}
